import {gql} from '@apollo/client';
import {useLazyQuery} from '@apollo/client/react';

// Droits nécessaires : USER_COMPANY_BENEFIT ou ADMIN_COMPANY_BENEFIT
const GET_COMPANY_BENEFIT_INVOICE = gql`
  query CompanyBenefitInvoice($uuid: ID!) {
    companyBenefitInvoice(uuid: $uuid) {
      amountExcludingVat
      amountExcludingVatEur
      benefitType
      boondManagerAdvantageId
      comment
      companyBenefitInvoiceFileUuid
      createdAt
      currency
      invoiceDate
      month
      totalAmount
      totalAmountEur
      uuid
      vatList {
        vatAmount
        vatAmountEur
        vatRate
        vatUuid
      }
      year
    }
  }
`;

export const useCompanyBenefitInvoice = () => {
    const [getCompanyBenefitInvoice, { loading, error, data, refetch }] = useLazyQuery(GET_COMPANY_BENEFIT_INVOICE, {
        fetchPolicy: "network-only",
    });

    return {
        loading,
        error,
        data: data?.companyBenefitInvoice,
        refetch,
        getCompanyBenefitInvoice: (uuid) => getCompanyBenefitInvoice({ variables: { uuid } }),
    };
};
